<template>
	<div>
		<buttonlist
			@help="help"
			@opentable="opentable"
			@search="search"
			@reflash="reflash"
			@print="print"
			ref="SetBtn"
		></buttonlist>
		<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li class="left" ref="left">
				<wTable
						id="xpane-0"
						:data="dataSet"
						:loading="loading"
						queryData="wavierview"
						:filter_language="['BillStatus']"
						:filter_thousandth="['DefectNum','material_cost','mancharge_cost','outsource_cost']"
						:header="tableHeader"
						@edits="editInfo"
						@rowdblclick="openEdit"
						:option="tableOption"
						:checkflg="false"
						ref="singleTable"
				></wTable>
			</li>
			<li class="resize" ref="resize">
				<i class="el-icon-caret-right" @click="leftt(0)"></i>
				<i class="el-icon-caret-left" @click="leftt(1)"></i>
			</li>
			<li class="mid" ref="mid">
				<div  style="float:right;position: relative;">
					<el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
				</div>
				<div>
					<table>
						<tr>
							<td style="width:60px">{{$t('getapi[8509]')}}</td>
							<td style="width:150px;">
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.BillCode" :readonly="true" class="readO"></el-input>
							</td>
							<td style="width:60px">{{$t('getapi[895]')}}</td>
							<td style="width:150px;">
								<routejump :urlNo="5">
									<el-input
											v-model="dataDetail.CMrbBill.ItemCode"
											type="text"
											readonly
											class="readO"
											size="mini"
									>
										<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectItem"></i>

									</el-input>
								</routejump>
							</td>
							<td style="width:60px">{{$t('getapi[546]')}}</td>
							<td style="width:150px;">
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.ItemName" :readonly="true" class="readO"></el-input>
							</td>
							<td style="width:60px">{{$t('getapi[8510]')}}</td>
							<td style="width:150px;">
								<el-select filterable v-model="dataDetail.CMrbBill.ProcessPoint" :readonly="true" class="readO" size="mini" @change="getProcessPoint">
									<el-option v-for="item in processpointarr" :key="item.Code" :label="item.Name"
											   :value="item" size="mini"></el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<td>{{$t('getapi[8511]')}}</td>
							<td colspan="7">
								<el-input type="textarea" :rows="1" size="text" v-model="dataDetail.CMrbBill.DefectRemark" :readonly="true" class="readO"></el-input>
							</td>
						</tr>
						<tr>
							<td>{{$t('getapi[8514]')}}</td>
							<td colspan="7">
								<el-input type="textarea" :rows="1" size="text" v-model="dataDetail.CMrbBill.ReReason" :readonly="true" class="readO"></el-input>
							</td>
						</tr>
						<tr>
							<td>{{$t('getapi[552]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.BillStatusName" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[2203]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.BaseBillCode" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[8515]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.CarCode" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[8516]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.CarDepart" :readonly="true" class="readO"></el-input>
							</td>
						</tr>
						<tr>
							<td>{{$t('getapi[8517]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.ClaimCode" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[410]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.CreateUserName" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[135]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.CreateTime" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[733]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.ModifyUserName" :readonly="true" class="readO"></el-input>
							</td>
						</tr>
						<tr>
							<td>{{$t('getapi[1210]')}}</td>
							<td>
								<el-input type="text" size="text" v-model="dataDetail.CMrbBill.ModifyTime" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[12932]')}}</td>
							<td>
								<el-input type="text" size="text" :value="expmrbtype(mrbtype)" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[6871]')}}</td>
							<td>
								<routejump :urlNo="6">
									<el-input
											v-model="dataDetail.CMrbBill.qa_name"
											type="text"
											:readonly="true" class="readO"
											size="mini"
									>
										<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee()"></i>
									</el-input>
								</routejump>
							</td>
							<td>{{$t('getapi[12964]')}}</td>
							<td>
								<el-input type="number" autocomplete="off" title="" size="text" v-model="dataDetail.CMrbBill.material_cost" :readonly="true" class="readO"></el-input>
							</td>
						</tr>
						<tr>
							<td>{{$t('getapi[12965]')}}</td>
							<td>
								<el-input type="number" autocomplete="off" title="" size="text" v-model="dataDetail.CMrbBill.mancharge_cost" :readonly="true" class="readO"></el-input>
							</td>
							<td>{{$t('getapi[12966]')}}</td>
							<td>
								<el-input type="number" autocomplete="off" title="" size="text" v-model="dataDetail.CMrbBill.other_cost" :readonly="true" class="readO"></el-input>
							</td>
						</tr>
					</table>
				</div>
				<el-tabs>
					<el-tab-pane :label="$t('getapi[8586]')">
						<div>
							<el-table
									id="xdetilpane-0"
									:data="dataDetail.CMrbBillPartList"
									:highlight-current-row="true"
									:height="tableHeight - 250"
									header-row-class-name="headerclass"
									border
									size="mini"
									style="width: 100%; margin-top:2px"
									:header-cell-style="$limits.headerClass"
									ref="singleTable1"
							>
								<el-table-column type="expand">
									<template slot-scope="props">
										<el-table
												:data="props.row.SubPartList"
												:highlight-current-row="true"
												header-row-class-name="headerclass"
												border
												size="mini"
												style="width: 100%; margin-top:2px"
												:header-cell-style="$limits.headerClass"
												:row-class-name="tableRowClassNameSub"
										>
											<el-table-column prop="Part_Code" :label="$t('getapi[2863]')" width="130">
											</el-table-column>
											<el-table-column show-overflow-tooltip prop="Part_Version" :label="$t('getapi[113]')" width="60"></el-table-column>
											<el-table-column prop="DefectNum" :label="$t('getapi[6214]')" width="80" align="right">
											</el-table-column>
											<el-table-column prop="DefectContent" :label="$t('getapi[8518]')" width="100">
											</el-table-column>
											<el-table-column prop="PO_Code" :label="$t('getapi[1710]')" width="80">
											</el-table-column>
											<el-table-column prop="material_cost" :label="$t('getapi[12964]')" width="80" align="right"></el-table-column>
											<el-table-column prop="mancharge_cost" :label="$t('getapi[12965]')" width="80" align="right"></el-table-column>
											<el-table-column prop="outsource_cost" :label="$t('getapi[7567]')" width="80" align="right"></el-table-column>
											<el-table-column prop="Remark" :label="$t('getapi[143]')" width="100">
											</el-table-column>
										</el-table>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Routing_Sequence" :label="$t('getapi[573]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Part_Code" :label="$t('getapi[2863]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Part_Version" :label="$t('getapi[113]')"></el-table-column>
								<el-table-column prop="regist_no" :label="$t('getapi[1744]')"></el-table-column>
								<el-table-column prop="DefectNum" :label="$t('getapi[6214]')" align="right">
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="DefectContent" :label="$t('getapi[8518]')">
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[3100]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="PersonLiable" :label="$t('getapi[12931]')">
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="PO_Code" :label="$t('getapi[1710]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')">
								</el-table-column>
								<el-table-column prop="HandleOpinion" :label="$t('getapi[8519]')"></el-table-column>
								<el-table-column prop="HandleType" :label="$t('getapi[12930]')">
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="ManHour" :label="$t('getapi[8520]')" align="right">
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="MatetialAmount" :label="$t('getapi[8521]')" align="right">
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="CostAmount" :label="$t('getapi[8522]')" align="right">
								</el-table-column>
								<el-table-column prop="material_cost" :label="$t('getapi[12964]')" width="80" align="right"></el-table-column>
								<el-table-column prop="mancharge_cost" :label="$t('getapi[12965]')" width="80" align="right"></el-table-column>
								<el-table-column prop="outsource_cost" :label="$t('getapi[7567]')" width="80" align="right"></el-table-column>
								<el-table-column prop="HandleRemark" :label="$t('getapi[8523]')">
								</el-table-column>
								<el-table-column fixed="right" :label="$t('getapi[6048]')" width="120">
									<template slot-scope="scope">
										<el-button @click.native.prevent="handle(scope.row)" type="text" size="mini">{{$t('getapi[8531]')}}</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>
					<el-tab-pane :label="$t('getapi[2408]')">
						<el-table
								:data="dataDetail.CMrbBillAudit"
								:highlight-current-row="true"
								header-row-class-name="headerclass"
								border
								size="mini"
								style="width: 100%; margin-top:5px"
								:header-cell-style="$limits.headerClass"
						>
							<el-table-column type="selection" v-if="false"></el-table-column>
							<el-table-column show-overflow-tooltip prop="PostTypeName" :label="$t('getapi[1833]')" width="100"></el-table-column>
							<el-table-column prop="Auditer" :label="$t('getapi[4043]')" width="80">
							</el-table-column>
							<el-table-column prop="AuditTime" :label="$t('getapi[732]')" width="150">
							</el-table-column>
							<el-table-column prop="Remark" :label="$t('getapi[143]')" width="100">
							</el-table-column>
						</el-table>
					</el-tab-pane>
					<el-tab-pane :label="$t('getapi[6421]')">
						<el-table
								:data="dataDetail.Attr"
								v-loading="loading"
								:highlight-current-row="false"
								show-overflow-tooltip="true"
								border
								stripe
								size="mini"
								header-row-class-name="headerclass"
						>
							<el-table-column show-overflow-tooltip prop="Node_Name"
											 :label="$t('getapi[3590]')"></el-table-column>
							<el-table-column show-overflow-tooltip prop="Doc_Type"
											 :label="$t('getapi[6423]')"></el-table-column>
							<el-table-column show-overflow-tooltip prop="Doc_Size"
											 :label="$t('getapi[7875]')"></el-table-column>
							<el-table-column show-overflow-tooltip prop="Upload_Person"
											 :label="$t('getapi[6425]')"></el-table-column>
							<el-table-column show-overflow-tooltip prop="Upload_Time"
											 :label="$t('getapi[6426]')"></el-table-column>
							<el-table-column prop="operate" :label="$t('getapi[6048]')">
								<template slot-scope="scope">
									<el-button @click.native.prevent="open(scope)" type="text" size="mini">{{
										$t('getapi[3611]') }}
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</el-tabs>

			</li>
		</ul>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="100"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="wavierview" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[962]')" queryData="wavierview" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>

		<!-- 项目代号 -->
		<selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage=true
				  :postUrl="'Basic/GetENGITEMList'" @callback="getItem" ref="itemcode"></selector>
		<!--选择物料编码-->
		<selector :isVisible="false" :selectType="0" :isBatch=true :isSplitPage=true
				  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="part"></selector>
		<!--选择物料编码-->
		<selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true
				  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="partsingle"></selector>
		<!-- 添加不良品零件 -->
		<selector :isVisible="false" :isBatch=true :selectType="0" :isSplitPage=true
				  :postUrl="'/Basic/Popup/GetDirectReportPopuDataList'" @callback="getBill" ref="bill"></selector>
		<!-- 质量负责人 -->
		<selector :isVisible="false" :isSplitPage="true" :isBatch=false :postUrl="'/MRB/GetQuanlityEmployeeList'"
				  @callback="getEmployee" ref="employee"></selector>

		<el-dialog v-dialogDrag :visible.sync="handleVisible" :title="$t('getapi[8531]')" width="760px" :close-on-click-modal="false">
			<div style="width:100%">
				<table>
					<tr>
						<td style="width:60px">{{$t('getapi[8509]')}}</td>
						<td style="width:150px;">
							<el-input type="text" size="text" v-model="handleDetail.BillCode" :readonly="true" class="readO"></el-input>
						</td>
						<td style="width:60px">{{$t('getapi[8684]') + $t('getapi[4525]')}}</td>
						<td style="width:150px;">
							<el-input size="text" v-model="handleDetail.ConcessionQty" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="true" class="readO"></el-input>
						</td>
						<td style="width:60px">{{$t('getapi[8685]') + $t('getapi[4525]')}}</td>
						<td style="width:150px;">
							<el-input size="text" v-model="handleDetail.RepairQty" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="true" class="readO"></el-input>
						</td>
					</tr>
					<tr>
						<td>{{$t('getapi[8686]') + $t('getapi[4525]')}}</td>
						<td>
							<el-input size="text" v-model="handleDetail.ScrapQty" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="true" class="readO"></el-input>
						</td>
						<td>{{$t('getapi[8687]') + $t('getapi[4525]')}}</td>
						<td>
							<el-input size="text" v-model="handleDetail.ReturnQty" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="true" class="readO"></el-input>
						</td>
						<td>{{$t('getapi[8801]') + $t('getapi[4525]')}}</td>
						<td>
							<el-input size="text" v-model="handleDetail.OtherQty" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="true" class="readO"></el-input>
						</td>
					</tr>
					<tr>
						<td >{{$t('getapi[8520]')}}</td>
						<td >
							<el-input size="text" v-model="handleDetail.ManHour" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="true" class="readO"></el-input>
						</td>
						<td>{{$t('getapi[8521]')}}</td>
						<td>
							<el-input size="text" v-model="handleDetail.MatetialAmount" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="true" class="readO"></el-input>
						</td>
						<td>{{$t('getapi[8522]')}}</td>
						<td>
							<el-input size="text" v-model="handleDetail.CostAmount" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="true" class="readO"></el-input>
						</td>
					</tr>
					<tr>
						<td>{{$t('getapi[8519]')}}</td>
						<td colspan="5">
							<div style="display: flex">
								<div style="width:550px;min-height:20px;border:1px solid #DCDFE6;border-radius:4px;	background-color: #F5F7FA!important;">
									<span style="white-space: normal" id="content1"></span>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td>{{$t('getapi[8523]')}}</td>
						<td colspan="5">
							<!--<el-input class="content" type="text" size="text" style="width:95%"></el-input>-->
							<div style="display: flex">
								<div style="width:550px;min-height:20px;border:1px solid #DCDFE6;border-radius:4px;	background-color: #F5F7FA!important;">
									<span style="white-space: normal" id="content2"></span>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td>{{$t('getapi[12930]')}}</td>
						<td colspan="5">
							<el-input size="text" v-model="handleDetail.HandleType" type="text" :readonly="true" class="readO"></el-input>
						</td>
					</tr>
				</table>
			</div>
			<el-table
					:data="handleDetail.ls"
					:highlight-current-row="true"
					header-row-class-name="headerclass"
					border
					size="mini"
					style="width: 100%; margin-top:5px"
					:header-cell-style="$limits.headerClass"
			>
				<el-table-column type="selection" v-if="false"></el-table-column>
				<el-table-column show-overflow-tooltip prop="PostTypeName" :label="$t('getapi[1833]')" width="100"></el-table-column>
				<el-table-column prop="Auditer" :label="$t('getapi[4043]')" width="80">
				</el-table-column>
				<el-table-column prop="AuditTime" :label="$t('getapi[732]')" width="150">
				</el-table-column>
				<el-table-column prop="Remark" :label="$t('getapi[143]')" width="100">
				</el-table-column>
			</el-table>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="handleVisible = false">{{ $t('getapi[2054]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="emojiVisible">
			<textarea id="subText" style="width:635px;" v-model="emojiContent"></textarea>
			<div class="wrapper">
				<span v-html="content"></span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="emojiVisible = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="commitHWZ()" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visAddType" width="25%" :close-on-click-modal="false" >
			<el-radio v-model="mrbtype" label="0">{{$t('getapi[19]')}}</el-radio>
			<el-radio v-model="mrbtype" label="1">{{$t('getapi[12397]')}}</el-radio>
			<el-radio v-model="mrbtype" label="2">{{$t('getapi[8683]')}}</el-radio>
			<el-radio v-model="mrbtype" label="3">{{$t('getapi[12973]')}}</el-radio>
			<span slot="footer" class="dialog-footer">
				<el-button @click="visAddType = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmAdd">{{ $t('getapi[4943]') }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    import wantEmoji from '@/utils/wEmoji.js'
export default {
	name:'wavierview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
        return {
            tableHeader: [],
            isVisible: false, // 查询列表是否显示
            queryData: [], // 查询数组
            userData: [], // 用户信息
            DbTbNames: '',
            dataSet: [], // 主表数据
            pageIndex: 1, // 当前页
            pageSize: this.$http.getPageSize('mrbview'), // 当前页数据量
            total: 0, // 数据总量
            SelectIndex: 0, //当前页面
            loading: false, // 主表加载状态
            dataDetail:{
                CMrbBill:{
                    BillCode: '',
                    ItemCode: '',
                    ItemName: '',
                    ProcessPoint: '',
                    ProcessPointID: '',
                    DefectRemark: '',
                    CreateTime: '',
                    CreateUserName: '',
                    CreateUserID: '',
                    ModifyTime: '',
                    ModifyUserName: '',
                    ModifyUserID: '',
                    BillStatus: '',
                    BillStatusName: '',
                    BaseBillCode: '',
                    ReReason: '',
                    CarCode: '',
                    CarDepart: '',
                    ClaimCode: ''
                },
                CMrbBillPartList:[],
                CMrbBillAudit:[],
            },
            oldDataDetail: '',
            addoredit: 0,
            btn: {
                handle: true,
                audit:false,
            },
            oldrow: '',
            iscontinuedblclick: true,
            timeId: null,
            code: '',
            processpointarr:[],
            selectData: [],
            selectDataSub: [],
            handleDetail:{}, //不良品处理意见
            handleVisible: false,
            auditVisible: false,
            handletypearr: [
                {
                    label: this.$t('getapi[8684]'),//'让步使用',
                    value: 1
                },{
                    label: this.$t('getapi[8685]'),//'返工返修',
                    value: 2
                },{
                    label: this.$t('getapi[8686]'),//'报废',
                    value: 3
                },{
                    label: this.$t('getapi[8687]'),//'退供应商',
                    value: 4
                },{
                    label: this.$t('getapi[224]'),//'其他',
                    value: 5
                },
            ],
            auditstatusarr:[
                {
                    label: this.$t('getapi[8688]'),//'单据提交',
                    value: 1
                },
                {
                    label: this.$t('getapi[8689]'),//'质量评审',
                    value: 15
                },
            ],
            oneormore: 1,
            rowindex: -1,
            subrowindex: -1,
            uploadurl: '',
            fileparm: {
                code: '',
                data_type: 12,
                Login_Group:'',
                Login_DB:'',
            },
            fileList: [],
            emojiVisible: false,//绘文字
            emojiContent: '',
            we: null,
            editType: 1,//1:不良品意见2：不良品意见备注
            scrollTop:0,
            scrollTop1:0,
            mrbtype:'0', //MRB类型
            visAddType: false,//选择MRB类型弹窗
            selectDataView:[],

            //导入数据
            uploadurl_data: '',
            fileList_data: [],
            file_data: null,
        }
	},
    watch:{
        dataSet: function(){
            let that = this
            that.$nextTick(function() {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.colsort()
		that.userData = sessionStorage.getItem('userData');
        that.cararr = Array.methods.getCarTypeList();
        that.processpointarr = Array.methods.getMRBRoutingList();
        that.$limits.dragControllerDiv();
        that.oldDataDetail = JSON.stringify(that.dataDetail)
        that.authority()
        that.$nextTick(function () {
            that.$processdata.initForm()
        })
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('wavierview', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1138]"),this.$t("getapi[16]"));
        },
		authority() {
			let that = this;
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'wavierview');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/MRB/WavierDataList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
		// 导出
		exps() {
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "wavierview",
                fromname: that.$t('getapi[13276]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
        leftt(e) {
            var left = document.getElementsByClassName('left');
            var mid = document.getElementsByClassName('mid');
            var Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            if (e == 1) {
                left[0].style.width = '0px';
                mid[0].style.width = bw - 13 + 'px';
            } else {
                left[0].style.width = bw - 50 + 'px';
                mid[0].style.width = '0px';
            }
        },
        openEdit() {
            let that = this
            clearTimeout(that.timeId)
            if(!that.iscontinuedblclick){
                return
            }
            let left = document.getElementsByClassName('left');
            let mid = document.getElementsByClassName('mid');
            let Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            left[0].style.width = '0px';
            mid[0].style.width = '100%';
        },
        colseEdit(){
            let that = this
            let left = document.getElementsByClassName('left');
            let mid = document.getElementsByClassName('mid');
            let Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            left[0].style.width = '100%';
            mid[0].style.width = '0px'
        },
        // 根据ID获取详情数据
        editInfo(row) {
            let that = this
            if(that.code == row.BillCode){
                return
            }
            that.code = row.BillCode
            that.getDetail(row.BillCode)
        },
        // 刷新
        reflash() {
            let that = this;
            that.getView();
            if(that.code != ''){
                that.getDetail(that.code)
			}
        },
        getDetail(code) {
            let that = this;
            that.addoredit = 1
            let parm = {
                BillCode: code
            }
            let loadingInstance = Loading.service(Common.maskoption);
            that.$http.urlpost('/MRB/GetMRBBillInfo', parm, function (res) {
                if (res.Success == 1) {
                    that.dataDetail = res.DataContent;
                    that.oldDataDetail = JSON.stringify(that.dataDetail)
                    that.authority();
                }
                loadingInstance.close()
            });
        },
        expStatus(val){
            let that = this
            if(val == 1){
                return that.$t('getapi[8684]')//'让步使用'
            } else if(val == 2){
                return that.$t('getapi[8685]')//'返工返修'
            } else if(val == 3){
                return that.$t('getapi[8686]')//'报废'
            } else if(val == 4){
                return that.$t('getapi[8687]')//'退供应商'
            } else if(val == 5){
                return that.$t('getapi[224]')//'其他'
            } else {
                return ''
            }
        },
        selectItem() {
            let that = this;
            that.$refs.itemcode.clearInput(true);
        },
        getItem(data) {
            let that = this
            console.log(data)
            that.dataDetail.CMrbBill.ItemCode = data.ITEM_CODE
            that.dataDetail.CMrbBill.ItemName = data.ITEM_NAME
            that.dataDetail.CMrbBill.qa_name = data.QUSER_NAME
            that.dataDetail.CMrbBill.qa_id = data.QUSER_ID
        },
        checkDataChange(){
            let that = this
            //能打开此页面即拥有保存权限
            let datacopy = that.dataDetail
            for(let i = 0;i<datacopy.CMrbBillPartList.length;i++){
                delete datacopy.CMrbBillPartList[i]['index']
                for(let j=0;j<datacopy.CMrbBillPartList[i].SubPartList.length;j++){
                    delete datacopy.CMrbBillPartList[i].SubPartList[j]['index']
                }
            }
            let flag =  that.oldDataDetail != JSON.stringify(datacopy)
            return flag
        },
        // 重新评审MRB单
        reBill(){
            let that = this
            let parm = {
                billcode: that.dataDetail.CMrbBill.BillCode
            }
            that.$http.urlpost('/MRB/MRBReBill', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.getDetail(that.code)
                }
            });
        },
        handle(row){
            let that = this
            //let row = that.dataDetail.CMrbBillPartList[0]
            that.handleDetail = {
                BillCode: row.BillCode,
                HandleID: row.HandleID,
                ListID: row.ListID,
                HandleOpinion: row.HandleOpinion,
                ConcessionQty: row.ConcessionQty,
                RepairQty: row.RepairQty,
                ScrapQty: row.ScrapQty,
                ReturnQty: row.ReturnQty,
                OtherQty: row.OtherQty,
                ManHour: row.ManHour,
                MatetialAmount: row.MatetialAmount,
                CostAmount: row.CostAmount,
                HandleRemark: row.HandleRemark,
                ls: that.dataDetail.CMrbBillAudit,
                HandleType:row.HandleType,
                /*[
                    {
                        AuditID: '',
                        BillCode: row.BillCode,
                        AuditerID: '',
                        Auditer: '',
                        AuditStatus: '',
                        AuditType: '',
                        AuditTime: '',
                        PostType: '',
                        PostTypeName: '质量部',
                        Remark: '',
                        Sort: 1
                    },
                    {
                        AuditID: '',
                        BillCode: row.BillCode,
                        AuditerID: '',
                        Auditer: '',
                        AuditStatus: '',
                        AuditType: '',
                        AuditTime: '',
                        PostType: '',
                        PostTypeName: '物料部计划',
                        Remark: '',
                        Sort: 2
                    },
                    {
                        AuditID: '',
                        BillCode: row.BillCode,
                        AuditerID: '',
                        Auditer: '',
                        AuditStatus: '',
                        AuditType: '',
                        AuditTime: '',
                        PostType: '',
                        PostTypeName: '事业部',
                        Remark: '',
                        Sort: 3
                    },
                    {
                        AuditID: '',
                        BillCode: row.BillCode,
                        AuditerID: '',
                        Auditer: '',
                        AuditStatus: '',
                        AuditType: '',
                        AuditTime: '',
                        PostType: '',
                        PostTypeName: '物料部采购',
                        Remark: '',
                        Sort: 4
                    },
                    {
                        AuditID: '',
                        BillCode: row.BillCode,
                        AuditerID: '',
                        Auditer: '',
                        AuditStatus: '',
                        AuditType: '',
                        AuditTime: '',
                        PostType: '',
                        PostTypeName: '相关部门',
                        Remark: '',
                        Sort: 5
                    },
                ]*/
            }
            that.handleVisible = true
            setTimeout(() => {
                document.querySelector("#content1").innerHTML = that.explainEmoji(that.handleDetail.HandleOpinion);
                document.querySelector("#content2").innerHTML = that.explainEmoji(that.handleDetail.HandleRemark);
            }, 500);
        },
        explainEmoji(str){
            if(str != null && str != undefined && str != ''){
                var reg = /\[wem:(\w+):wem\]/g
                return str.replace(reg,function(str,target){
                    var tempArr = target.split("_"),
                        eid = tempArr.shift(),
                        type = tempArr.pop(),
                        name = tempArr.join("_");
                    let path = "./static/emojiSources/gyfh/";
                    let url = name+"."+type;
                    console.log(path+url)
                    return '<img src="'+path+url+'" />';
                });
            } else {
                return ''
            }
        },
        saveHandle(){
            let that = this
            if(that.handleDetail.ConcessionQty == 0 &&
                that.handleDetail.RepairQty == 0 &&
                that.handleDetail.ScrapQty == 0 &&
                that.handleDetail.ReturnQty == 0 &&
                that.handleDetail.OtherQty == 0){
                that.$message.warning(this.$t('getapi[1657]'))
                return
            }
            let parm = that.handleDetail
            parm.LangType = that.$processdata.getLang()
            that.btn.handle = false
            that.$http.urlpost('/MRB/MRBBillSaveHandle', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.getDetail(that.code)
                    that.handleVisible = false
                }
                that.btn.handle = true
            });
        },
        explain(val){
            let that = this
            if(val == 1){
                return this.$t('getapi[8684]')
            } else if(val == 2){
                return this.$t('getapi[8685]')
            } else if(val == 3){
                return this.$t('getapi[8686]')
            } else if(val == 4){
                return this.$t('getapi[8687]')
            } else if(val == 5){
                return this.$t('getapi[224]')
            } else {
                return ''
            }
        },
        open(row) {
            let that = this;
            const key = generatekey(8); // 也可直接指定key let key = 'des';
            that.loading = true;
            that.userData = sessionStorage.getItem('userData');
            let parm = {
                Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                CType:row.row.ConfigType,
                OthInfo:'',
                NodeId:row.row.Node_ID,
            };
            console.log(parm);
            that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                if (res.Success == 1) {
                    let hrefurl =res.DataContent;
                    window.open(hrefurl);
                }
                that.loading = false;
            });
        },
        print(){
            let that = this;
            if (that.$limits.fnIsEmpty(that.dataDetail.CMrbBill.BillCode)) {
                return;
            }
            that.$refs.SetBtn.SetOneBtnEnable('print', false);
            let parm = {
                "po_no": that.dataDetail.CMrbBill.BillCode,
                "TemplateName": "34Wavier.xlsx"
            };
            console.log('WavierPrint')
            that.$http.urlpost('/Print/WavierPrint', parm, function (res) {
                that.$refs.SetBtn.SetOneBtnEnable('print', true);
                if (res.Success == 1) {
                    let hrefurl = res.Key;
                    window.open(hrefurl);
                }
            });
        },
        //添加绘文字
        addHWZ(val){
            let that = this
            that.editType = val
            that.emojiVisible = true
            if(val == 1){
                that.emojiContent = that.handleDetail.HandleOpinion
            } else {
                that.emojiContent = that.handleDetail.HandleRemark
            }
            setTimeout(() => {
                let text = document.querySelector("#subText");
                that.we = new wantEmoji({
                    wrapper : ".wrapper",
                    callback : function(emojiCode){
                        text.value += emojiCode;
                    },
                    autoInit : true
                });
            }, 500);
        },
        commitHWZ(){
            let that = this
            console.log(document.querySelector("#subText").value)
            that.emojiContent = document.querySelector("#subText").value
            if(that.editType == 1){
                that.handleDetail.HandleOpinion = that.emojiContent
                document.querySelector("#content1").innerHTML = that.we.explain(that.emojiContent);
            } else if(that.editType == 2){
                that.handleDetail.HandleRemark = that.emojiContent
                document.querySelector("#content2").innerHTML = that.we.explain(that.emojiContent);
            }
            that.emojiVisible = false
        },
        expmrbtype(val){
            let that = this
            if(val == 0){
                return that.$t('getapi[19]')
            } else if(val == 1){
                return that.$t('getapi[12397]')
            } else if(val == 2){
                return that.$t('getapi[8683]')
            } else if(val == 3){
                return that.$t('getapi[12973]')
            }
        },
        //选择质量负责人
        selectEmployee(val){
            let that = this
            that.$refs.employee.clearInput(true);
        },
        getEmployee(data){
            let that = this
            console.log(data)
            that.dataDetail.CMrbBill.qa_name = data.name
            that.dataDetail.CMrbBill.qa_id = data.code
        },
        handleSelectionChangeview(val){
            let that = this;
            that.selectDataView = [];
            for (let i = 0; i < val.length; i++) {
                that.selectDataView.push({BillCode:val[i].BillCode});
            }
        },
        reflashMRB(val){
            let that = this
            let parm = {
                ls:that.selectDataView,
                iscontinue:val
            }
            that.$http.urlpost('/MRB/MRBCost', parm, function (res) {
                if(res.Success == 1){
                    that.getView();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                } else if(res.Success == 2){
                    that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.reflashMRB(2);
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                }
            });
        },
        getProcessPoint(data){
            let that = this
            console.log(data)
            that.dataDetail.CMrbBill.ProcessPoint = data.Name
            that.dataDetail.CMrbBill.ProcessPointID = data.Code
        },
        //导入
        downloadModel(){
            let that = this
            let param={
                url:'/MRB/GetMRBImportTemplate'
            }
            Array.methods.DownLoadTemp(param);
        },
        handlePreview_data(file) {
            console.log(file);
        },
        handleRemove1(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview1(file) {
            console.log("handlePreview"+file);
        },
        handleChange1(file, fileList) {
            let that = this;
            that.file_data = file.raw
        },
        handleSuccess1(res, file, fileList) {
            let that = this;
            let response = res.Success;
            if (response == 0) {
                that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
            } else {
                console.log('导入成功')
            }
            that.fileList_data=[];
            that.loading = false;
        },
        handleError1(err, file, fileList) {
            let that = this;
            that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            that.loading = false;
        },
        uploadFile1(){
            let that = this;
            let datetime = Common.methods.getDatetime()
            let formData = new FormData(); //formdata格式
            formData.append('file', that.file_data);
            formData.append('LangType', that.$processdata.getLang())
            that.$http.urlpost('/MRB/MRBImportUpload', formData, function (res) {
                if (res.Success == 1) {
                    let data = res.DataContent.dt
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.CMrbBillPartList= [...that.dataDetail.CMrbBillPartList,{
                            so_code: '',
                            report_id: '',
                            ListID: '',
                            BillCode: '',
                            Routing_Sequence: '',
                            Part_Code: data[i].part_code,
                            Part_Version: data[i].part_version,
                            DefectNum: data[i].defectnum,
                            DefectContent: data[i].defectcontent,
                            PersonLiable: data[i].personliable,
                            PO_Code: "",
                            regist_no: "",
                            Remark: data[i].remark,
                            HandleID: '',
                            HandleOpinion: "",
                            HandleType: "",
                            ConcessionQty: '',
                            RepairQty: '',
                            ScrapQty: '',
                            ReturnQty: '',
                            OtherQty: '',
                            ManHour: '',
                            MatetialAmount: '',
                            CostAmount: '',
                            HandleRemark: "",
                            material_cost: '',
                            mancharge_cost: '',
                            outsource_cost: '',
                            measure_unit: data[i].measure_unit,
                            SubPartList:[],
                        }]
                    }
                }
            });
        },
    }
};
</script>

<style scoped lang="less">
	@import url('../../../assets/css/wEmoji.css');
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
